var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.698 6H14.3052C15.6216 6 16.6579 7.05664 16.6579 8.39886V15.6011C16.6579 16.9434 15.6216 18 14.3052 18H4.698C3.38157 18 2.25 16.9434 2.25 15.6011V8.39886C2.25 7.05664 3.38157 6 4.698 6ZM5.16856 7.34222C5.73434 7.34222 6.10967 7.72489 6.10967 8.30176C6.10967 8.78153 5.73434 9.2613 5.16856 9.2613C4.698 9.2613 4.22745 8.78153 4.22745 8.30176C4.22745 7.7306 4.698 7.34222 5.16856 7.34222ZM21.75 7.63351V16.4693C21.75 16.7549 21.4699 16.9491 21.1842 16.7549C19.9574 15.9838 18.641 15.2185 17.4142 14.4474V9.55259C18.641 8.78153 19.9574 8.01618 21.1842 7.24512C21.6548 7.05664 21.75 7.43931 21.75 7.63351Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.45338 20.4857C3.15175 20.2018 3.13736 19.7272 3.42125 19.4255L18.3932 3.51783C18.6771 3.2162 19.1517 3.20181 19.4534 3.4857C19.755 3.76959 19.7694 4.24425 19.4855 4.54588L4.51355 20.4536C4.22966 20.7552 3.75501 20.7696 3.45338 20.4857Z",
    fill: "#D13131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/cameraOff.0c447779.svg";
export { ForwardRef as ReactComponent };